import React from "react";
import { Typography, Box } from "@material-ui/core";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

import useStyles from "./style";

interface DefaultBreadcrumbProps {
  title: string;
  description?: string;
}

export const Breadcrumb = ({ title, description }: DefaultBreadcrumbProps) => {
  const classes = useStyles();

  /*const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const onBackButtonClick = () => {
    const url = location.pathname;

    const urlDuMenuParent = getParentUrl(url, items(t));

    return !!description && urlDuMenuParent
      ? () => navigate(urlDuMenuParent)
      : () => navigate(URLS.BOARD);
  };*/

  return (
    <Box className={classes.box}>
      {/*<KeyboardBackspaceIcon
        classes={{ root: classes.icon }}
        onClick={onBackButtonClick()}
      />*/}
      <Typography variant="h6">{title}</Typography>

      {description && (
        <>
          <ArrowForwardIosIcon classes={{ root: classes.secondIcon }} />
          <Typography variant="body1" className={classes.subtitle}>
            {description}
          </Typography>
        </>
      )}
    </Box>
  );
};
